export { BaselineComponent } from './baseline.component';
export { Remediate } from './remediate';
export const href = 'https://docs.microsoft.com/en-us/powershell/module/sharepoint-online/set-spotenant';
